import uniqueId from 'lodash/uniqueId'
import { StrictMode, useRef, useMemo } from 'react'
import type { VFC } from 'react'
import { Theme } from '@opallabs/gem'
import {
  InputLabel,
  DeprecatedSingleSelect,
  DeprecatedSingleSelectOption,
} from '@opallabs/lapidary'
import { ImageSize } from '../../types'
import { humanizeSystemName } from '../section_helpers'
import * as styles from '../styles'
import type { SidebarProps } from '../types'

export type Props = Pick<SidebarProps, 'theme'> &
  Readonly<{
    alignment: ImageSize
    onChange(value: ImageSize): void
  }>

export const SizeSection: VFC<Props> = ({
  alignment,
  onChange,
  theme = 'light',
}) => {
  const htmlId = useRef(uniqueId('sidebar-image-size'))

  const options: Array<DeprecatedSingleSelectOption> = useMemo(
    () =>
      Object.values(ImageSize).map((value) => ({
        value,
        label: humanizeSystemName(value),
      })),
    []
  )

  return (
    <StrictMode>
      <InputLabel
        inputId={htmlId.current}
        styleOverrides={styles.label(theme as Theme)}
        text="Image Size"
        theme={theme}
      />

      <DeprecatedSingleSelect
        initialSelection={options.find((option) => option.value === alignment)}
        options={options}
        onChange={(option) => option && onChange(option.value as ImageSize)}
      />
    </StrictMode>
  )
}
SizeSection.displayName = 'Hubble: SizeSection ← Sidebar ← SlideEditor'
